export function scrollToElement(element, behavior = 'smooth', offset = 0) {
  let top = element.getBoundingClientRect().top;
  top -= document.body.getBoundingClientRect().top;
  top -= offset;
  window.scrollTo({ behavior, top });
}

export const isMobile = () => {
  const userAgent = navigator.userAgent;
  const isMobileUserAgent = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  const isMobileViewport = window.innerWidth < 768;

  return isMobileUserAgent || isMobileViewport;
};

export const rescue = (fn, fallback = null) => {
  try {
    return fn();
  } catch (e) {
    if (typeof fallback === 'function') {
      return fallback(e);
    }
    return fallback;
  }
};
